import { Card as MuiCard, CardActionArea, CardContent, Typography, useTheme } from "@mui/material";
import { FC } from "react";

interface Props{
  title:string
  content:any
  className?: string
  sx?: any
}

const Card:FC<Props> = (props) => {
    const theme = useTheme();

  return (
    <MuiCard className={props.className} sx={{flexGrow:1, margin:{xs:0,sm:'0 20px'}, maxWidth:600,...props.sx}}>
      <CardActionArea>
        <CardContent>
          <Typography
            variant="h5"
            gutterBottom
            component="div"
            style={{
              fontFamily: "Nunito",
              color: theme.palette.primary.main,
            }}
          >
            {props.title}
          </Typography>
          {typeof props.content === 'string' ? 
          <Typography variant="body2" color="text.secondary">
            {props.content}  
          </Typography>:
          props.content}
        </CardContent>
        {/* <CardActions style={{ justifyContent: "flex-end" }}>
          <Button size="small" variant="text">
            Ver más
          </Button>
        </CardActions> */}
      </CardActionArea>
    </MuiCard>
  );
};

export default Card;
